import { getBrowserApi, getRecordingApi } from '@fullstory/browser-api';
import { AppState } from '@fullstory/redux';
import { UserBase, UserBaseV2 } from './types';
import { stringFromRole } from '@fullstory/util/roles';
import { createSelector } from 'reselect';

const getOrgId = (state: AppState) => state.fullstory.orgId;
const getEmail = (state: AppState) => state.fullstory.userInfo.email;
const getSeatRole = (state: AppState) => state.fullstory.seatRole;
export const trackUserBaseSelector = createSelector(
  getOrgId,
  getEmail,
  getSeatRole,
  (orgId, email, seatRole): UserBase => ({
    org_id_str: orgId,
    user_email_str: email,
    user_seat_type_str: stringFromRole(seatRole),
    current_session_str: getBrowserApi(window)?.getCurrentSessionURL?.() ?? null,
  }),
);

export const trackUserBaseV2Selector = createSelector(
  trackUserBaseSelector,
  (userBase): UserBaseV2 => ({
    org_id: userBase.org_id_str,
    user_email: userBase.user_email_str,
    user_seat_type: userBase.user_seat_type_str,
    current_session: getRecordingApi(window)?.('getSession', { format: 'url' }) ?? null,
  }),
);
